import { parseFilter } from "colbi_web_ui/lib/utils";

export const settingsQueries = (args) => {
    const { section, filter, locale, organizationId } = args || {};
    const pagesWithLocale = [
        "nc_rules",
        "packages",
        "kpis",
        "custom_reports",
        "translations_table",
    ];

    return section
        ? [
            {
                resource: section,
                args: {
                    pageSize: 20000,
                    page: 0,
                    locale: pagesWithLocale.includes(section) ? locale : undefined,
                    organizationId: organizationId || undefined,
                    filter: filter
                        ? { type: "[FilterInput!]", value: parseFilter(filter) }
                        : undefined,
                    sort: args.sort
                        ? { type: "[SortInput!]", value: parseFilter(args.sort) }
                        : undefined,
                },
                body: `__typename, items{...${section}},hasMore,total,filters{ prop, name, type, list, disableOperators }`,
                isDatagridReq: true,
                downloadable: true,
                downloadFilePrefixName: section === "users" ? "users" : section,
            },
        ]
        : [];
};
